import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

interface Props {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<Props> = ({ children }) => {
  const { authState } = useAuth();

  if (authState.loading) {
    return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  }

  if (!authState.user) {
    return <Navigate to="/login" replace />;
  }

  // Block access if email is not confirmed
  if (!authState.user.email_confirmed_at) {
    return <Navigate to="/activate" replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute; 